/**
 * Percent text for the collateral policy editors.
 *
 * The policy stores ratios (0.85); the editors show percents (85). Advance
 * Rate Programs and Asset Class Eligibility printed one decimal and
 * Concentration Limits printed none, so one policy read 90.0% on one page and
 * 25% on the next, and a stored 12.5 showed as 13 (r3 fi-g7-2, fi-g7-12).
 * Every policy editor formats through this module.
 *
 * The money-percent display ruling (r3 fi-g7-12) drops the trailing .0: a
 * whole percent prints whole (90), and a fractional one keeps its one decimal
 * (12.5).
 */

/**
 * Up to one decimal, no trailing zero. Fixed to en-US with no grouping
 * separator because the text is also the value of a number input, which
 * rejects '1,000' and a decimal comma.
 */
const PCT_FORMAT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
  useGrouping: false,
});

/** Percent text for a stored ratio: 0.85 -> "85", 0.125 -> "12.5". */
export function pctText(ratio: number): string {
  return PCT_FORMAT.format(ratio * 100);
}

/**
 * The stored ratio for a percent string, or undefined when the text is empty
 * or not a number. Undefined is never turned into 0: a 0 would read as a limit
 * the institution set.
 */
export function parsePct(text: string): number | undefined {
  const trimmed = text.trim();
  if (trimmed === '') return undefined;
  const n = Number(trimmed);
  return Number.isFinite(n) ? n / 100 : undefined;
}
